import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import { createI18n } from "vue-i18n";
import { MathfieldElement } from "mathlive";

const i18n = createI18n({
  // numberFormats,
  locale: "ar", // default locale
  messages: {
    en: require("./locales/en.json"),
    ar: require("./locales/ar.json"),
  },

  legacy: true, // enable Vue 3's new composition API
  globalInjection: true, // inject $dir into all components
  global: {
    en: { dir: "ltr" },
    ar: { dir: "rtl" },
  },
});

loadFonts();

const app = createApp(App);
app.component("MathfieldElement", MathfieldElement);
app.use(router).use(store).use(vuetify).use(i18n).mount("#app");
